import { Component, OnInit, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";

@Component({
    selector: "app-loading-dialog",
    templateUrl: "./loading-dialog.component.html",
    styleUrls: ["./loading-dialog.component.scss"],
    standalone: false
})
export class LoadingDialogComponent implements OnInit {

  constructor(
    public dialogRef: VngDialogRef<LoadingDialogComponent>,
    @Inject(VNG_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }
}
